export default __webpack_public_path__ + "70bc5597d002d906a36929b69938ed63.twig";